import { render, staticRenderFns } from "./consultant.vue?vue&type=template&id=d4b0aa62&scoped=true&"
import script from "./consultant.vue?vue&type=script&lang=ts&"
export * from "./consultant.vue?vue&type=script&lang=ts&"
import style0 from "./consultant.vue?vue&type=style&index=0&id=d4b0aa62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b0aa62",
  null
  
)

export default component.exports